/** Minimal dependency-free bar chart — flex bars (cap width, grow from bottom),
 *  so it looks right for any N (a stretched SVG made 2 bars fill the card). */
export function BarChart({
	data,
	height = 160,
}: {
	data: Array<{ label: string; value: number }>;
	height?: number;
}) {
	if (!data.length) return <div className="text-xs text-muted">No data.</div>;
	const max = Math.max(...data.map((d) => d.value), 1);
	return (
		<div className="flex items-stretch gap-2" style={{ height }}>
			{data.map((d) => (
				<div
					key={d.label}
					className="flex flex-1 flex-col items-center justify-end"
					style={{ maxWidth: 48 }}
					title={`${d.label}: ${d.value}`}
				>
					<div
						className="w-full rounded-t bg-primary"
						style={{ height: `${(d.value / max) * 100}%`, minHeight: 3 }}
					/>
				</div>
			))}
		</div>
	);
}
